var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartphoneIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2060_769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.94736 0.5H3.05229C2.62284 0.5 2.27344 0.849359 2.27344 1.27883V11.7211C2.27344 12.1506 2.62282 12.5 3.05229 12.5H8.94736C9.3768 12.5 9.72619 12.1506 9.72619 11.7211V1.27883C9.72619 0.849359 9.37683 0.5 8.94736 0.5ZM5.99984 11.6946C5.69278 11.6946 5.44385 11.4456 5.44385 11.1386C5.44385 10.8315 5.69278 10.5826 5.99984 10.5826C6.30689 10.5826 6.55582 10.8315 6.55582 11.1386C6.5558 11.4456 6.30687 11.6946 5.99984 11.6946ZM8.6722 9.39221C8.6722 9.54854 8.54548 9.67527 8.38915 9.67527H3.61052C3.4542 9.67527 3.32747 9.54854 3.32747 9.39221V1.7499C3.32747 1.59357 3.4542 1.46684 3.61052 1.46684H8.38915C8.54548 1.46684 8.6722 1.59357 8.6722 1.7499V9.39221Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2060_769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneIconBlue);
export default __webpack_public_path__ + "static/media/smartphone_icon_blue.5093017bf97ef62e030f43fba9226990.svg";
export { ForwardRef as ReactComponent };